import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {useAuth} from '../../modules/auth'
import moment from 'moment'

interface PatientPageProps {
  claimDetails?: any
  formData?: any
  onFormDataChange?: (data: any) => void
}

const PatientPage: React.FC<PatientPageProps> = ({claimDetails, formData, onFormDataChange}) => {
  const user = useAuth()
  const {auth} = useAuth()
  const [memberDetail, setMemberDetail] = useState<any>(null)
  const [claim, setClaim] = useState<any>(null)
  const [logs, setLogs] = useState<any>([])

  useEffect(() => {
    if (claimDetails?.memberDetail) {
      // console.log('claimDetails?.memberDetail', claimDetails?.memberDetail)
      const parsedMemberDetail = JSON.parse(claimDetails.memberDetail)
      setMemberDetail(parsedMemberDetail)
      // console.log('CCTE : ', JSON.parse(claimDetails.memberDetail))
      setClaim(claimDetails.claimNumber)
    } else {
      console.warn('Claim details not found')
    }
  }, [claimDetails])

  // useEffect(() => {
  //   if (formData && onFormDataChange) {
  //     onFormDataChange(formData)
  //   }
  // }, [formData])

  const formatDateWithAge = (dateString: string): string => {
    const date = new Date(dateString)
    const options: Intl.DateTimeFormatOptions = {day: 'numeric', month: 'long', year: 'numeric'}
    const formattedDate = date.toLocaleDateString('id-ID', options) // Format date in Indonesian locale

    // Calculate age
    const today = new Date()
    const birthDate = new Date(dateString)
    const age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()
    const ageString =
      monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate()) ? age - 1 : age

    return `${formattedDate} (${ageString} tahun)`
  }

  const formatJoinDate = (dateString: string): string => {
    const date = new Date(dateString)
    const options: Intl.DateTimeFormatOptions = {year: 'numeric', month: 'numeric', day: 'numeric'}
    return date.toLocaleDateString('id-ID', options) // Format date in Indonesian locale
  }

  // useEffect(() => {
  //   fetchClaimDetailHeader()
  // }, [])

  // const fetchClaimDetailHeader = async () => {
  //   const claimNumber = claimDetails.claim.claimNumber
  //   const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/GetDetailClaimHeader?claimNumber=${claimNumber}`
  //   const headers = {
  //     Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
  //   }
  //   try {
  //     const response = await axios.get(apiUrl, {headers})

  //     setLogs(response.data.data.logs)
  //   } catch (err) {
  //     console.error('Error fetching ICD details:', err)
  //   }
  // }

  if (!memberDetail) {
    return <div>Loading...</div> // Show loading state if memberDetail is not yet available
  }

  return (
    <div className='patient-container'>
      <div className='patient-data'>
        <h3>Data Pasien</h3>
        <div className='form-group'>
          <label>Nomor Kartu</label>
          <input type='text' value={memberDetail?.CardNumber || ' - '} readOnly />
        </div>
        {/* <div className='form-group'>
          <label>Nomor Klaim</label>
          <input type='text' value={claim || ' - '} readOnly />
        </div> */}
        <div className='form-group'>
          <label>Nama Pasien</label>
          <input type='text' value={memberDetail?.MemberName || ' - '} readOnly />
        </div>
        <div className='form-group'>
          <label>Plan Pasien</label>
          <input type='text' value={memberDetail?.PlanName || ' - '} readOnly />
        </div>
        <div className='form-group'>
          <label>Status Pasien</label>
          <div
            className='status-badge'
            style={{backgroundColor: memberDetail?.MemberStatus === true ? '#4caf50' : '#f44336'}}
          >
            {memberDetail?.MemberStatus === true ? 'Aktif' : 'Tidak Aktif'}
          </div>
        </div>
        <div className='form-group'>
          <label>Jenis Kelamin</label>
          <input
            type='text'
            value={memberDetail?.Gender === 'M' ? 'Laki-laki' : 'Perempuan'}
            readOnly
          />
        </div>
        <div className='form-group'>
          <label>Tanggal Lahir</label>
          <input
            type='text'
            value={memberDetail?.DateOfBirth ? formatDateWithAge(memberDetail.DateOfBirth) : ' - '}
            readOnly
          />
        </div>
        <div className='form-group'>
          <label>Tanggal Bergabung</label>
          <input
            type='text'
            value={memberDetail?.JoinDate ? formatJoinDate(memberDetail.JoinDate) : ' - '}
            readOnly
          />
        </div>
        <div className='form-group'>
          <label>Nama Perusahaan</label>
          <input
            type='text'
            value={
              memberDetail?.IsAso
                ? memberDetail?.CorporateName || memberDetail?.CustomerName
                : memberDetail?.InsurerName || ' - '
            }
            readOnly
          />
        </div>
        <div className='form-group'>
          <label>Catatan Khusus</label>
          <div
            style={{
              whiteSpace: 'pre-wrap',
              wordWrap: 'break-word',
              background: '#f0f0f4',
              border: '1px solid #e0e0e5',
              borderRadius: '4px',
              padding: '8px',
              color: '#666',
              fontSize: '14px',
              width: '100%',
              textAlign: 'justify',
            }}
          >
            {memberDetail?.Remark || 'Tidak Ada'}
          </div>
        </div>
      </div>

      {/* <div className='log-status'>
        <h3>Log Status</h3>
        {logs.map((log: any, index) => {
          return (
            <div className='log-item'>
              <div className='circle-wrapper'>
                <div className='dot'></div>
                <div className='circle'></div>
              </div>
              {index != logs.length - 1 ? <div className='log-line'></div> : null}
              <div className='log-details'>
                <p className='log-title'>{log.action}</p>
                <p>
                  {log.remark} BY <strong className='log-creator'>{log.createdBy}</strong>
                </p>
                <p className='log-date'>
                  {moment(log.createdAt, 'YYYY-MM-DD HH:mm:ss').format('D MMMM YYYY  HH:mm:ss')}
                </p>
              </div>
            </div>
          )
        })}
      </div> */}

      <style>{`
        .patient-container {
          display: flex;
          justify-content: space-between;
          gap: 20px;
          max-width: 100%;
        }
        .patient-data {
          flex: 1;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          gap: 16px;
        }
        .patient-data h3 {
          width: 100%;
          margin-bottom: 12px;
          font-size: 18px;
          color: #333;
          position: relative;
          padding-bottom: 8px;
        }
        .patient-data h3:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 40px;
          height: 3px;
          background: #4a90e2;
          border-radius: 3px;
        }
        .form-group {
          display: flex;
          flex-direction: column;
          border-radius: 8px;
          padding: 12px;
          width: calc(50% - 8px);
          background: #f8f9fa;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
          transition: all 0.2s ease;
        }
        .form-group:hover {
          box-shadow: 0 3px 6px rgba(0,0,0,0.08);
          transform: translateY(-2px);
        }
        @media (max-width: 768px) {
          .form-group {
            width: 100%;
          }
        }
        label {
          font-weight: 500;
          margin-bottom: 6px;
          color: #5a5f7a;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        input {
          padding: 10px 0 8px;
          border: none;
          outline: none;
          width: 100%;
          background: transparent;
          color: #333;
          font-size: 14px;
          font-weight: 500;
          border-bottom: 1px solid #eaeaea;
        }
        input:focus {
          border-color: #4a90e2;
        }
        input[readonly] {
          color: #666;
          cursor: not-allowed;
          opacity: 0.9;
          background-color: #f0f0f4;
          border-radius: 4px;
          padding: 8px;
          border: 1px solid #e0e0e5;
          font-weight: normal;
        }
        .status-badge {
          display: inline-block;
          padding: 6px 12px;
          background-color: #4caf50;
          color: white;
          border-radius: 20px;
          font-weight: 500;
          text-align: center;
          width: fit-content;
          font-size: 13px;
          box-shadow: 0 2px 4px rgba(76, 175, 80, 0.2);
        }
        .log-status {
          width: 350px;
          padding: 16px;
          background: #f9f9f9;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        .log-item {
          display: flex;
          align-items: flex-start;
          position: relative;
          margin-top: 8px;
        }
        .circle-wrapper {
          position: relative;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 2px dashed #6d7194;
          display: flex;
          justify-content: center;
          align-items: center;
          left: 0px;
          top: 0;
        }
        .circle {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background-color: #fff;
          border: 4px solid #6d7194;
        }
        .log-line {
          width: 3px;
          height: 84%;
          background-color: transparent;
          position: absolute;
          left: 13px;
          top: 27px;
          border-left: 1px dashed #6d7194;
        }
        .log-details {
          display: flex;
          flex-direction: column;
          margin-left: 12px;
        }
        .log-title {
          font-weight: bold;
          color: #6d7194;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        .log-creator {
          color: #0094a2;
          font-weight: 500;
        }
        .log-date {
          color: #6d7194;
          font-size: 12px;
        }
      `}</style>
    </div>
  )
}

export default PatientPage
